import { useMemo } from 'react'
import { AutocompleteDataSource, FilteractionDataSource } from 'types/shared'
import { FilteractionParams } from 'utils/apiTypes'

type Props = {
  filteraction: string
  filteractionParams: FilteractionParams[]
  manifestDataSources: AutocompleteDataSource[]
  endpoint?: string
}

export default function useDataSourcesFromFilteraction({
  filteraction,
  filteractionParams,
  manifestDataSources,
  endpoint
}: Props) {
  const legacyDataSource = useMemo<FilteractionDataSource>(
    () => ({
      type: 'filteraction',
      config: {
        filteraction: filteraction,
        interpolated_params: filteractionParams,
        endpoint: endpoint
      }
    }),
    [filteraction, filteractionParams, endpoint]
  )

  const dataSources = useMemo(
    () =>
      filteraction || endpoint
        ? [...manifestDataSources, legacyDataSource]
        : manifestDataSources,
    [filteraction, legacyDataSource, manifestDataSources, endpoint]
  )

  return dataSources
}
